import { expressQuerySelector, expressEventListener, expressAddClass, expressRemoveClass } from "../../common/html";
import { login, logout } from "../../services/inline-edit-service";
import { compositeDisposable } from "../../utils/disposable";

export interface IInlineEditCardComponent {
	dispose: () => void;
}

export function initializeInlineEditCard(): IInlineEditCardComponent {
	const disposible = compositeDisposable([]);

	const element = expressQuerySelector(document, ".technical-inline-edit", false);
	if (!element) return;

	const hideClass = "u-hide";

	const button = expressQuerySelector(element, ".technical-editing-card-collapse-button");
	const dataContainer = expressQuerySelector<HTMLElement>(element, ".technical-inline-edit__data-container");
	const loginContainer = expressQuerySelector<HTMLElement>(element, ".technical-inline-edit__login-container");
	const loggingInContainer = expressQuerySelector<HTMLElement>(element, ".technical-inline-edit__logging-in-container");
	const loggingOutContainer = expressQuerySelector<HTMLElement>(
		element,
		".technical-inline-edit__logging-out-container",
	);
	const logoutButtonEl = expressQuerySelector<HTMLElement>(element, ".technical-inline-edit-logout");

	const initGoogleClient = () => {
		// authenticate - login
		google.accounts.id.initialize({
			client_id: loginContainer.dataset.googleClientId,
			use_fedcm_for_button: true,
			callback: async (response: google.accounts.id.CredentialResponse) => {
				if (!response) return;

				// hide the button
				expressAddClass(loginContainer.firstElementChild as HTMLElement, "u-hide");
				// show the loading-div
				expressRemoveClass(loggingInContainer, "u-hide");

				await login(response.credential);
				window.location.reload();
			},
		});

		google.accounts.id.renderButton(loginContainer, {
			type: "standard",
			shape: "rectangular",
			size: "large",
			width: 250,
			locale: window.context.locale,
		});
	};

	disposible.addMany([
		expressEventListener(button, "click", () => {
			element.classList.toggle("t-inline-editing-card--collapsed");
		}),
		expressEventListener(logoutButtonEl, "click", async () => {
			// show login again
			expressAddClass(dataContainer, hideClass);
			expressRemoveClass(loggingOutContainer, hideClass);

			await logout();

			window.location.reload();
		}),
	]);

	// Add the script only once
	const googleScriptSrc = "https://accounts.google.com/gsi/client?hl=" + window.context.language;
	const scripts = document.getElementsByTagName("script");
	for (const item of scripts) {
		if (item.src === googleScriptSrc) {
			// Script-tag already exists. Manually call init-func
			initGoogleClient();
			return;
		}
	}

	// load google script async
	const scriptEl = document.createElement("script");
	scriptEl.type = "text/javascript";
	scriptEl.async = true;
	scriptEl.defer = true;
	scriptEl.onload = initGoogleClient;
	scriptEl.src = googleScriptSrc;
	const firstScriptEl = document.getElementsByTagName("script")[0];
	firstScriptEl.parentElement!.insertBefore(scriptEl, firstScriptEl);

	return {
		dispose: disposible.dispose,
	};
}
